<template>
  <div class="u-relative">
      <slot></slot>
  </div>
</template>

<script>
export default
{
  props:
  {
    width: { type: Number, default: 0 },
    height: { type: Number, default: 0 },
  },

  mounted() {
    const ratio = this.gcd(this.width, this.height)

    let aspectRatio = 100 * (this.height / ratio) / (this.width / ratio)

    this.$el.style.paddingBottom = aspectRatio + '%'
  },

  methods: {
    gcd(a, b)
    {
        return (b === 0) ? a : this.gcd (b, a%b);
    }
  }

}
</script>